import React, { useEffect, useState } from "react";
import Swal from "../../utils/swal";
import { showSuccessToast, showErrorToast } from "../../utils/swalToast";
import apiClient from "../../utils/apiClient";
import { numberToRupiah } from "../../utils/format";
import { useUser } from "../../pages/UserContext";
import RowActionsMenu from "../custom/RowActionsMenu";
import CustomButton from "../custom/CustomButton";
import CustomDataGrid from "../custom/CustomDataGrid";
import EditPenelitianModal from "./EditPenelitianModal";
import InsertPenelitianModal from "./InsertPenelitianModal";

export default function ResearchData() {
  const userDetails = useUser();
  const [page, setPage] = useState(1);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState(false);

  const [openInsertModal, setOpenInsertModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [editTarget, setEditTarget] = useState({ userId: null, researchId: null });

  useEffect(() => {
    const fetchData = async () => {
      try {
        let url = `/research/details?isDeleted=0`;
        if (userDetails.role !== "admin") {
          url += `&lecturerId=${userDetails.uuid}`;
        }
        const response = await apiClient.get(url);
        setRows(
          response.data.data.map((research, index) => ({
            no: index + 1 + (page - 1) * 10,
            id: research.id,
            idDosen: research.id_dosen,
            namaAnggota: research.lecturer_name,
            bidangPenelitian: research.bidang,
            mulaiPenelitian: research.tanggal_mulai,
            topik: research.topik,
            sumberBiaya: research.research_budget[0]?.sumber_biaya || "",
            budget: research.research_budget[0]
              ? numberToRupiah(research.research_budget[0].budget)
              : "",
            actual: research.research_budget[0]
              ? numberToRupiah(research.research_budget[0].actual)
              : "",
          }))
        );
      } catch (error) {
        console.error("Error fetching journals", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [page, refresh, userDetails.role, userDetails.uuid]);

  const handleAddResearch = () => {
    setOpenInsertModal(true);
  };

  const handleInsertSuccess = () => {
    setOpenInsertModal(false);
    setRefresh((prev) => !prev);
  };

  const handleEditResearch = (userId, researchId) => {
    setEditTarget({ userId, researchId });
    setOpenEditModal(true);
  };

  const handleEditSuccess = () => {
    setOpenEditModal(false);
    setRefresh((prev) => !prev);
  };

  const handleDeleteResearch = async (researchId) => {
    Swal.fire({
      text: "Kamu akan menghapus penelitian ini",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#003158",
      cancelButtonColor: "#A92027",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await apiClient.post(`/research/delete`, { id: researchId });
          showSuccessToast(response.data.msg);
          setRefresh(!refresh);
        } catch (error) {
          showErrorToast(error.response.data.msg);
        }
      }
    });
  };

  const columns = [
    { field: "no", headerName: "No.", flex: 1 },
    { field: "namaAnggota", headerName: "Nama Anggota", flex: 1 },
    {
      field: "bidangPenelitian",
      headerName: "Bidang Penelitian",
      flex: 1,
    },
    { field: "mulaiPenelitian", headerName: "Mulai Penelitian", flex: 1 },
    { field: "topik", headerName: "Topik", flex: 1 },
    { field: "sumberBiaya", headerName: "Sumber Biaya", flex: 1 },
    { field: "budget", headerName: "Budget", flex: 1, minWidth: 160 },
    { field: "actual", headerName: "Actual", flex: 1, minWidth: 160 },
    {
      field: "actions",
      headerName: "Action",
      renderCell: (params) => (
        <RowActionsMenu
          actions={[
            {
              label: "Edit",
              onClick: () => handleEditResearch(params.row.idDosen, params.row.id),
            },
            {
              label: "Hapus",
              onClick: () => handleDeleteResearch(params.row.id),
              danger: true,
            },
          ]}
        />
      ),
      flex: 1,
    },
  ];

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <CustomButton
        onClick={handleAddResearch}
        text="Tambah Penelitian"
        isFullWidth={false}
        baseColor="#003158"
        hoverColor="#00213A"
      />
      <br></br>
      <CustomDataGrid
        rows={rows}
        columns={columns}
        page={page}
        setPage={setPage}
        loading={loading}
      />
      <EditPenelitianModal
        open={openEditModal}
        onClose={() => setOpenEditModal(false)}
        userId={editTarget.userId}
        researchId={editTarget.researchId}
        onSuccess={handleEditSuccess}
      />
      <InsertPenelitianModal
        open={openInsertModal}
        onClose={() => setOpenInsertModal(false)}
        onSuccess={handleInsertSuccess}
      />
    </div>
  );
}
